import Link from "next/link";

import Button from "components/common/button";

import JettasinIcon from "assets/svg/jettasin-icon.svg";

import styles from "./styles.module.css";

export const JettasinRedirectSection = () => (
  <div className={styles.container}>
    <div className={styles.information}>
      <JettasinIcon />
      <p className={styles.informationTitle}>Güvenilir ve profesyonel taşınma için çözüm net: Emlakjet </p>
    </div>
    <div className={styles.moveHouseButton}>
      <Link href="/jettasin/" rel="noopener noreferrer" target="_blank">
        <Button size="M">Hemen Taşın</Button>
      </Link>
    </div>
  </div>
);
